'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style", "index"];
import * as React from 'react';
import { useRenderElement } from '@mui/x-scheduler-internals/base-ui-copy';
import { TimelineGridBodyRowContext } from "./TimelineGridBodyRowContext.mjs";

/**
 * A unified row container that provides its index to child cells
 * (TitleRow, EventRow) for keyboard navigation.
 * The `index` is passed as a prop (e.g. from the virtualizer's renderRow).
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const TimelineGridBodyRow = /*#__PURE__*/React.forwardRef(function TimelineGridBodyRow(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      index
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const contextValue = React.useMemo(() => ({
    index
  }), [index]);
  const element = useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [elementProps, {
      role: 'row',
      // Reserve aria-rowindex=1 for the grid header row.
      'aria-rowindex': index + 2
    }]
  });
  return /*#__PURE__*/_jsx(TimelineGridBodyRowContext.Provider, {
    value: contextValue,
    children: element
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridBodyRow.displayName = "TimelineGridBodyRow";